<template>
  <div class="app">
    <Menu v-if="showHeader" />
    <router-view></router-view>
  </div>
</template>

<script setup lang="ts">
import Menu from './components/MenuComponent.vue'
import {onMounted, provide, ref, watch} from 'vue'
import { useRouter } from 'vue-router'
import {apiClient} from "@/api/http.ts";
import { offerStates } from '@/stores/offer'

const router = useRouter()

const showHeader = ref<boolean>(router.currentRoute?.value?.meta?.showHeader ?? false)

watch(
  () => router.currentRoute.value.meta.showHeader,
  (routeShowHeader) => {
    showHeader.value = routeShowHeader ?? false
  },
)

provide('offerStates', offerStates)
const loadOfferStates = async () => {
  apiClient.get('wiser/offertestatus').then((res) => {
    offerStates.value = res.data
  })
}
onMounted(() => {
  loadOfferStates()
})
</script>
